var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStep2Grafik01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 358,
    height: 346.27,
    viewBox: "0 0 358 346.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "step-2-grafik") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "step-2-grafik"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Step-Point"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Differenzmenge_2",
    "data-name": "Differenzmenge 2",
    d: "M74.106,339.633a55.84,55.84,0,0,0,50.2-80.221L79.737,289.476,48.84,333.6A55.8,55.8,0,0,0,74.106,339.633Zm-49.9-30.791h0l44.84-30.248,30.964-44.221A55.836,55.836,0,0,0,24.2,308.841Z",
    style: {
      fill: "#dbf1f7"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 74.145,
    cy: 283.797,
    r: 39.594,
    style: {
      fill: "#73c9e2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_256",
    "data-name": "Pfad 256",
    d: "M83.846,297.9H64.437v-4.083l6.97-7.045q3.1-3.172,4.045-4.4a9.668,9.668,0,0,0,1.367-2.269,5.779,5.779,0,0,0,.418-2.165,3.155,3.155,0,0,0-.922-2.489,3.572,3.572,0,0,0-2.459-.817,7.072,7.072,0,0,0-3.134.741,16.171,16.171,0,0,0-3.172,2.111l-3.19-3.778a20.815,20.815,0,0,1,3.4-2.474,12.478,12.478,0,0,1,2.944-1.111,15.083,15.083,0,0,1,3.57-.389,10.571,10.571,0,0,1,4.6.949,7.334,7.334,0,0,1,3.1,2.656,7.063,7.063,0,0,1,1.1,3.913,9.576,9.576,0,0,1-.675,3.6A13.817,13.817,0,0,1,80.3,284.3a51.071,51.071,0,0,1-4.99,5.036L71.749,292.7v.266h12.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "grafik-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lieferung"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_65",
    "data-name": "Pfad 65",
    d: "M204.518,126.176H245.96V70.919a4.606,4.606,0,0,0-4.6-4.6H181.494a4.606,4.606,0,0,0-4.6,4.6v50.652a4.606,4.606,0,0,0,4.6,4.6h4.6",
    style: {
      fill: "none",
      stroke: "#73c9e2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "4.537445817422139px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_66",
    "data-name": "Pfad 66",
    d: "M268.985,126.175h9.209a4.606,4.606,0,0,0,4.6-4.6V100.455a4.6,4.6,0,0,0-1.349-3.255l-15.72-15.723a4.6,4.6,0,0,0-3.252-1.349H245.961v46.047h4.6",
    style: {
      fill: "none",
      stroke: "#73c9e2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "4.537445817422139px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 195.308,
    cy: 126.176,
    r: 9.209,
    style: {
      fill: "none",
      stroke: "#73c9e2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "4.537445817422139px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 259.775,
    cy: 126.176,
    r: 9.209,
    style: {
      fill: "none",
      stroke: "#73c9e2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "4.537445817422139px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Paket"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vereinigungsmenge_1",
    "data-name": "Vereinigungsmenge 1",
    d: "M104.253,104.948,56.646,84.33,104.253,66.15,151.86,84.33v60.348l-47.607,21.184Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_58",
    "data-name": "Pfad 58",
    d: "M153.793,84.316v-.028a1.486,1.486,0,0,0-.014-.181.1.1,0,0,0-.005-.04,1.9,1.9,0,0,0-.04-.211h0a1.922,1.922,0,0,0-.065-.2l-.013-.034a1.943,1.943,0,0,0-.091-.188l-.019-.034a1.978,1.978,0,0,0-.112-.181l-.007-.009a1.943,1.943,0,0,0-.129-.16l-.025-.027a1.928,1.928,0,0,0-.15-.144l-.031-.026a1.921,1.921,0,0,0-.172-.129h0l-.013-.007a1.912,1.912,0,0,0-.181-.1l-.029-.015c-.049-.024-.1-.046-.152-.066l-47.6-18.186a1.934,1.934,0,0,0-1.379,0L55.957,82.523c-.052.02-.1.043-.152.066l-.028.015a1.948,1.948,0,0,0-.181.1l-.013.007h0a1.926,1.926,0,0,0-.172.129l-.031.026a1.9,1.9,0,0,0-.15.144l-.024.027a1.985,1.985,0,0,0-.13.161l-.006.008a1.967,1.967,0,0,0-.112.181l-.019.034a1.893,1.893,0,0,0-.091.188.1.1,0,0,1-.012.032,1.935,1.935,0,0,0-.066.2h0a1.906,1.906,0,0,0-.04.212.1.1,0,0,1-.005.04c-.007.061-.012.121-.014.181v60.39a1.934,1.934,0,0,0,1.148,1.767l47.608,21.18a1.95,1.95,0,0,0,.221.082l.06.016a1.89,1.89,0,0,0,.189.041l.068.011a1.926,1.926,0,0,0,.247.017h0a1.921,1.921,0,0,0,.246-.017l.07-.011a1.888,1.888,0,0,0,.187-.041l.062-.016a1.945,1.945,0,0,0,.221-.081l47.607-21.18a1.934,1.934,0,0,0,1.148-1.767V84.31M104.253,68.219l42.479,16.223-13.66,5.918L91.716,73.007Zm16.3,27.56-16.3,7.06-42.481-18.4,17.515-6.689Zm29.371,47.643-43.741,19.459V106.217l11.933-5.167,5.173-2.241v17.605l12.472-6.358V93.408l14.162-6.133Z",
    style: {
      fill: "#73c9e2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Bildmarke"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_7",
    "data-name": "Gruppe 7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_14",
    "data-name": "Pfad 14",
    d: "M130.246,133.216a.494.494,0,0,1-.527-.012l-4.765-3.137c-.244-.166-.319-.178-.53-.114l-7.646,2.59,6.112,3.223a.494.494,0,1,1-.463.873h0l-7.132-3.759a.5.5,0,0,1,.071-.909l8.742-2.96a1.437,1.437,0,0,1,1.388.224l4.766,3.136a.49.49,0,0,1,.143.678l0,.006a.477.477,0,0,1-.157.153Z",
    style: {
      fill: "#f59f40"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_15",
    "data-name": "Pfad 15",
    d: "M131.274,131.583a.5.5,0,0,1-.6-.064l-5.194-5.049a.917.917,0,0,0-.213-.2l-8.34,3.187.4.353a.5.5,0,0,1-.648.752l-.019-.017-.938-.842a.6.6,0,0,1-.087-.086.487.487,0,0,1-.119-.448.5.5,0,0,1,.308-.352l9.123-3.47a1.091,1.091,0,0,1,1.256.447l5.164,5.008a.5.5,0,0,1,.01.7.571.571,0,0,1-.1.079Z",
    style: {
      fill: "#f59f40"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_16",
    "data-name": "Pfad 16",
    d: "M131.57,131.2l-.051.03a.5.5,0,0,1-.656-.246h0l-3.677-8.128c-.087-.2-.11-.211-.31-.131l-5.557,2.247a.5.5,0,0,1-.528-.1l-.483-.451-2.725,1.178.367.716a.5.5,0,0,1-.885.45h0l-.5-.985a.839.839,0,0,1-.134-.4.454.454,0,0,1,.078-.289.581.581,0,0,1,.247-.206l3.465-1.5a.5.5,0,0,1,.536.094l.49.463,5.263-2.129a1.132,1.132,0,0,1,1.584.648l3.674,8.123a.493.493,0,0,1-.2.626Z",
    style: {
      fill: "#f59f40"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_8",
    "data-name": "Gruppe 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_17",
    "data-name": "Pfad 17",
    d: "M134.309,138.6a1.361,1.361,0,0,1-.519.185l-8.322,1.162a1.4,1.4,0,0,1-1.554-1.078l-.144-.654a1.346,1.346,0,0,1,.184-1.04,1.368,1.368,0,0,1,.867-.6l4.24-.909a1.369,1.369,0,0,1-.135-1.686l4.414-6.706a1.352,1.352,0,0,1,.861-.587l8.589-1.841a1.4,1.4,0,0,1,1.652,1.057l1.072,4.779-3.818.117a.894.894,0,0,0-.633.293l-6.426,7.249a1.452,1.452,0,0,1-.319.267Zm-9.661-1.44a.865.865,0,0,0-.4.939l.144.654a.907.907,0,0,0,1,.7l8.323-1.161a.888.888,0,0,0,.537-.288l6.426-7.249a1.383,1.383,0,0,1,.988-.461l3.222-.1-.943-4.184a.907.907,0,0,0-1.068-.681l-8.588,1.839a.88.88,0,0,0-.548.376l-4.413,6.705a.894.894,0,0,0,1.445,1.049l3.822-4.8.388.31-3.822,4.8a1.361,1.361,0,0,1-.968.513,1.407,1.407,0,0,1-.623-.094l.007.031-4.664,1a.946.946,0,0,0-.272.1Z",
    style: {
      fill: "#74c9e3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_18",
    "data-name": "Pfad 18",
    d: "M134.437,138.817a1.672,1.672,0,0,1-.611.217L125.5,140.2a1.651,1.651,0,0,1-1.83-1.268l-.144-.654a1.623,1.623,0,0,1,.213-1.231,1.6,1.6,0,0,1,1.024-.708l3.87-.834a1.622,1.622,0,0,1,.073-1.665l4.416-6.7a1.648,1.648,0,0,1,1.014-.7l8.59-1.84a1.647,1.647,0,0,1,1.944,1.246l1.009,4.487a.5.5,0,0,1-.092.413.484.484,0,0,1-.376.191l-3.519.11a.643.643,0,0,0-.452.208l-6.426,7.249a1.625,1.625,0,0,1-.378.314Zm-9.662-1.443a.614.614,0,0,0-.2.2.626.626,0,0,0-.085.474l.144.654a.659.659,0,0,0,.727.5l8.323-1.161a.6.6,0,0,0,.384-.207l6.426-7.249a1.623,1.623,0,0,1,1.163-.543l2.932-.086-.878-3.9a.652.652,0,0,0-.771-.5l-8.59,1.84a.61.61,0,0,0-.392.271l-4.414,6.706a.635.635,0,0,0,.109.824.662.662,0,0,0,.5.17.635.635,0,0,0,.447-.235l3.822-4.8a.5.5,0,0,1,.776.619l-3.822,4.8a1.61,1.61,0,0,1-1.143.606,1.553,1.553,0,0,1-.595-.066l-4.651.995a.611.611,0,0,0-.2.077Z",
    style: {
      fill: "#74c9e3"
    }
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2Grafik01);
export default __webpack_public_path__ + "static/media/step-2-grafik-01.958232fce441f74fdf5fbc36fb968e02.svg";
export { ForwardRef as ReactComponent };